const searchInput = document.getElementById('search-input');
const dropdownItems = document.querySelectorAll('.dropdown_list__item');
const tableRows = document.querySelectorAll('#engineers_list_table tbody tr');
const noResultsRow = document.getElementById('no-results-row');

let selectedCity = '';

function filterTable() {
    if (!searchInput) return;
    const query = searchInput.value.toLowerCase().replace(/\d+/g, '').trim();
    const city = $('#combo4').text() === 'All Cities' ? '' : $('#combo4').text();
    let visibleCount = 0;

    tableRows.forEach(row => {
        const address = (row.cells[0]?.textContent.toLowerCase().replace(/\d+/g, '').trim() || '');
        const rowCity = row.cells[1]?.textContent.trim() || '';
        const engineer = (row.cells[2]?.textContent.toLowerCase() || '');

        const matchSearch =
            address.includes(query) || engineer.includes(query);

        const matchCity = city === "" || rowCity === city;

        const visible = matchSearch && matchCity;
        row.style.display = visible ? "" : "none";
        if (visible) visibleCount++;
    });

    noResultsRow.style.display = visibleCount === 0 ? 'block' : 'none';
}
if(searchInput){
    searchInput.addEventListener('input', filterTable);
}
const target = $('[role="combobox"]')[0];
if (target) {
    const observer = new MutationObserver(() => {
        filterTable();
    });
    observer.observe(target, { childList: true, subtree: true });
}
dropdownItems.forEach(item => {
    item.addEventListener('click', () => {
        selectedCity = item.getAttribute('data-value') || "";

        filterTable();
    });
});



let isMobileToggleBound = false;

function tableToggle() {
    const isMobile = $(window).width() < 1024;

    if (isMobile && !isMobileToggleBound) {
        $('#engineers_list_table tbody tr > *:first-child').each(function (){
            const content = $(this).text();
            $(this).siblings().attr('aria-hidden', 'true');
            $(this).parent().prepend(`<button type="button" aria-expanded="false">${content}</button>`);
            $(this).remove();
        });
        $('body').on('click.mobileToggle', '#engineers_list_table tbody tr > *:first-child', function (e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $(this).attr('aria-expanded', $(this).hasClass('open') ? 'true' : 'false');
            $(this).siblings().attr('aria-hidden', $(this).hasClass('open') ? 'false' : 'true');
            $(this).siblings().slideToggle(150);
        });
        isMobileToggleBound = true;
    } else if (!isMobile && isMobileToggleBound) {
        $('#engineers_list_table tbody tr > *:first-child').each(function (){
            const content = $(this).text();
            $(this).parent().prepend(`<td>${content}</td>`);
            $(this).remove();
        });
        $('#engineers_list_table tbody tr td').each(function (){
            $(this).removeAttr('aria-hidden');
        });

        $('body').off('click.mobileToggle');
        isMobileToggleBound = false;
    }
}

$(document).ready(function () {
    tableToggle();
    $(window).on('resize', tableToggle);
});
